import { error } from "console";
import { AuditQuestion } from "../models/AuditQuestion";
import { Audit } from "../models/Audit";
import { AuditDetail } from "../models/AuditDetail";
import axios, { AxiosRequestConfig } from "axios";
import { saveAs } from "file-saver";
import { QuestionarySection } from "../models/QuestionarySection";
const API_BASE_URL = process.env.REACT_APP_AUDIT_API_URL;

const insertSection = async (section: QuestionarySection) => {
  const response = await fetch(`${API_BASE_URL}/QuestionarySection/Insert`, {
    method: "POST",
    headers: { "Content-Type": "application/json; charset= utf-8" },
    body: JSON.stringify(section),
  });

  return response;
};

const updateSection = async (section: QuestionarySection) => {
  const response = await fetch(`${API_BASE_URL}/QuestionarySection/Update`, {
    method: "POST",
    headers: { "Content-Type": "application/json; charset= utf-8" },
    body: JSON.stringify(section),
  });

  return response;
};

const deleteSection = async (section: QuestionarySection) => {
  const response = await fetch(`${API_BASE_URL}/QuestionarySection/Delete`, {
    method: "POST",
    headers: { "Content-Type": "application/json; charset= utf-8" },
    body: JSON.stringify(section),
  });

  return response;
};

export const updatePositions = async (
  updates: { sectionId: number; newPosition: number }[]
) => {
  const response = await fetch(
    `${API_BASE_URL}/QuestionarySection/UpdatePositions`,
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(updates),
    }
  );

  if (!response.ok) {
    throw new Error("Failed to update section positions");
  }

  return response;
};

const QuestionarySectionService = {
  insertSection,
  updateSection,
  deleteSection,
  updatePositions,
};

export default QuestionarySectionService;
